import { handleActions, createAction } from 'redux-actions';
import { SET_VEHICLE_TYPE } from './VehicleTypeReducer';

export const FETCH_OFFERS = createAction('FETCH/OFFERS');
export const FETCH_OFFERS_SUCCESS = createAction('FETCH/OFFERS/SUCCESS');
export const FETCH_OFFERS_FAIL = createAction('FETCH/OFFERS/FAIL');

export const FETCH_BUY_NOW_OFFERS = createAction('FETCH_BUY_NOW_OFFERS');
export const FETCH_BUY_NOW_OFFERS_FAIL = createAction('FETCH_BUY_NOW_OFFERS_FAIL');
export const FETCH_BUY_NOW_OFFERS_SUCCESS = createAction('FETCH_BUY_NOW_OFFERS_SUCCESS');


const initialState = {
  fetchOffersErrors: null,
};

const offersReducer = handleActions(
  {
    [FETCH_OFFERS_SUCCESS]: (state, { payload: offers, }) => {
      return { ...state, ...offers, };
    },
    [FETCH_OFFERS_FAIL]: (state, { payload: { error, }, }) => {
      return { ...state, fetchOffersErrors: error, };
    },
    [FETCH_BUY_NOW_OFFERS_SUCCESS]: (state, { payload: offers, }) => {
      return { ...state, ...offers, };
    },
    [FETCH_BUY_NOW_OFFERS_FAIL]: (state, { payload: { error, }, }) => {
      return { ...state, fetchOffersErrors: error, };
    },
    [SET_VEHICLE_TYPE]: () => {
      return initialState;
    },
  },
  initialState
);

export default offersReducer;
